import { Link } from 'react-router-dom';

export default function HeaderItem() {
  return (
    <>
      <ul id="menu-main" className="nav-menu float-xl-left text-lg-center dropdown-light">
        <li className="scroll ">
          <Link to="/">Navira Live</Link>
        </li>
      </ul>
      <ul id="menu-main" className="nav-menu float-xl-right text-lg-right dropdown-light">
        <li className="scroll ">
          <Link to="/login?">Login</Link>
        </li>
      </ul>
    </>
  );
}
